export default {
    CONFIRM_EMAILS: 'confirmEmails',
    CONFIRM_RCA: 'confirmRCA',
    CONFIRM_RCA_CHANGE: 'confirmRCAChange',
    CONTINUE: 'continue',
    STOP: 'stop',
    WRONG_LIST: 'wrong-list',
};
